import React from 'react';
import { Container, Row, Col } from 'reactstrap';

const WhiteBox = (props) => {
	var p0 = {};
	if (props.className) p0.className = props.className;
	if (props.style) p0.style = props.style;
	return (
		<Container {...p0}>
			<Row className="ad_whitebox_row">
				<Col className="ad_whitebox_col py-3" md="12">
					{props.children}
				</Col>
			</Row>
		</Container>
	);
};

export {
	WhiteBox,
}



// WEBPACK FOOTER //
// ./src/c/lib.js